
const notifyContainer = document.getElementById("notifications-container");
const notificationCloseIcon = notifyContainer.dataset.icon;

window.location.getParam = (parameterName) => {
  if (!parameterName) return null;
  var result = null,
    tmp = [];
  location.search
    .substr(1)
    .split("&")
    .forEach((item) => {
      tmp = item.split("=");
      result = tmp[0] === parameterName ? decodeURIComponent(tmp[1]) : result;
    });
  return result;
};

const notifyRemoveAll = () => {
  const notificationEls = notifyContainer.querySelectorAll(
    ".notification.open"
  );

  if (!notificationEls) return;

  const notificationsList = Array.from(notificationEls);

  const removeNext = () =>
    notificationsList.length > 0 &&
    setTimeout(() => {
      notifyRemove("", notificationsList.shift().id);
      removeNext();
    }, 300);

  removeNext();
};

const notifyRemove = (id, realId) => {
  let notificationEl = document.getElementById(
    realId ? realId : `notifyId_${id}`
  );

  if (!notificationEl) return;

  notificationEl.classList.remove("open");
  setTimeout(
    () =>
      (notificationEl = document.getElementById(
        realId ? realId : `notifyId_${id}`
      )) && notifyContainer.removeChild(notificationEl),
    1000
  );
};

const notifyShow = (
  title = "Information",
  message = "",
  type = "info", // info, error, success, warning
  duration = -1
) => {
  const notifyId = new Date().getTime();

  const notificationEl = document.createElement("div");
  notificationEl.classList.add("notification", "open", type);
  notificationEl.id = `notifyId_${notifyId}`;

  const notificationHeaderEl = document.createElement("div");
  notificationHeaderEl.classList.add("notification-header");

  const notificationTitleEl = document.createElement("h4");
  notificationTitleEl.innerText = title;

  const notificationCloseEl = document.createElement("img");
  notificationCloseEl.classList.add("close");
  notificationCloseEl.src = notificationCloseIcon;
  notificationCloseEl.onclick = () => notifyRemove(notifyId);

  notificationHeaderEl.append(notificationTitleEl, notificationCloseEl);
  notificationEl.appendChild(notificationHeaderEl);

  if (message) {
    const notificationMessageEl = document.createElement("p");
    notificationMessageEl.classList.add("notification-content");
    notificationMessageEl.innerText = message;

    notificationEl.appendChild(notificationMessageEl);
  }

  if (!!~duration) {
    setTimeout(() => notifyRemove(notifyId), duration);

    const notificationTimerEl = document.createElement("div");
    notificationTimerEl.classList.add("timer");
    notificationEl.appendChild(notificationTimerEl);

    let leftDuration = duration;

    const updateNotificationTimer = () => {
      leftDuration -= 24;
      notificationTimerEl.style.width = `${
        (leftDuration / duration) * 100
      }%`;

      if (leftDuration >= 24)
        return setTimeout(updateNotificationTimer, 24);
    };

    updateNotificationTimer();
  }

  notifyContainer.appendChild(notificationEl);

  return notifyId;
};

window.notifyHandler = {
  notifyShow,
  notifyRemoveAll,
};

window.dispatchEvent(new CustomEvent("onNotifyHandlerReady"));
